<template>
    <div class="infoBox">
    	<div class="headline textAlignCenter">Profil Status</div>
	    
	    <div class="progressRound" data-toggle="tooltip" data-placement="top" title="" data-original-title="Your progress">
	        <div v-if="currentCompletion >= 0.5" class="clip-1"><div class="slice-1" style="-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg);"></div></div>
	        <div v-if="currentCompletion < 0.5" class="clip-1"><div class="slice-1" :style="{'-webkit-transform':'rotate('+360*currentCompletion+'deg)','-moz-transform':'rotate('+360*currentCompletion+'deg)','-o-transform':'rotate('+360*currentCompletion+'deg)','transform':'rotate('+360*currentCompletion+'deg)'}"></div></div>
	        <div v-if="currentCompletion <= 0.5" class="clip-2"><div class="slice-2" style="-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg);"></div></div>
	        <div v-if="currentCompletion > 0.5" class="clip-2"><div class="slice-2" :style="{'-webkit-transform':'rotate('+360*(currentCompletion-0.5)+'deg)','-moz-transform':'rotate('+360*(currentCompletion-0.5)+'deg)','-o-transform':'rotate('+360*(currentCompletion-0.5)+'deg)','transform':'rotate('+360*(currentCompletion-0.5)+'deg)'}"></div></div>
	        <div class="label">{{completionLabel}}%</div>
	    </div>
	</div>
</template>

<script>
	export default {
		name: 'profileCompletion',
		props: {
            completion: String
        },
         data: function() {
        	return {
                currentCompletion: null,
                completionLabel: null
        	}
        },
        created: function() {
            this.currentCompletion = this.completion;
            this.completionLabel = Math.trunc(this.completion * 100);
            this.$bus.$on('changedCompletion', () => {
            	this.getCompletion();
            });
        },
        methods: {
        	loadProfileCompletionSuccess: function(data) {
        		this.currentCompletion = data;
                this.completionLabel = Math.trunc(data * 100);
        	},
            getCompletion: function() {
            	jQuery.ajax ({
                    url: '/getProfileCompletion',
                    type: 'GET',
                    dataType: "json",
                    success: this.loadProfileCompletionSuccess,
                    error: function() {console.log("error while getting profile completion value")}
                });
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileCompletion.vue?f50f2c0e